import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IAtgardPrimaryKey } from "../atgard/AtgardBaseCommand";

export class AvverkningsanmalanCommandBase extends BasicCommand<AvverkningsanmalanCommandBase> {
    readonly atgardGuid: string;
    readonly kontraktGuid: string;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Avverkningsanmalan";

    get primaryKey(): IAtgardPrimaryKey {
        return {
            atgardGuid: this.atgardGuid,
            kontraktGuid: this.kontraktGuid
        };
    }

    constructor(kontraktGuid: string, atgardGuid: string, typeName: string, commandType: CommandType) {
        super(typeName, AvverkningsanmalanCommandBase.$groupKey, commandType);
        this.atgardGuid = atgardGuid;
        this.kontraktGuid = kontraktGuid;
    }
}
